export default __webpack_public_path__ + "static/media/RobotoMono-Regular.418a8f9f.ttf";